module.exports = __webpack_public_path__ + "static/img/15areaA_4.198146a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/15areaA_4.png
// module id = 797
// module chunks = 1